export const syntheticDataGenerationContactFormId = 'contact-form-rwad';
